import behindLogin from "src/components/behindLogin/behindLogin";
import { Library } from "src/components/page-components/Library/Library";

export default behindLogin(Library);
